import { AllPaginationDefaults } from '../enum';
import { PaginationRequest } from '../Types';

export const requestAllItem: PaginationRequest = {
    page: AllPaginationDefaults.Page as number,
    pageSize: AllPaginationDefaults.PageSize as number,
    orderDirection: AllPaginationDefaults.Order,
    orderBy: AllPaginationDefaults.OrderBy as string,
};

export const allInPage = 400;
export const allCustomerInPage = 2200;